module.exports = __webpack_public_path__ + "static/media/mobile-dashed.9e026e7b.svg";